/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ACHAccountHolderTypeEnum = {
    type: 'Enum',
};